import { CommentAnswerCard } from '../CommentAnswerCard/CommentAnswerCard';

import type { TextAnswer } from '@/components/QuestionResultContainer/types';

interface PlainTextResultProps {
    answers: TextAnswer[];
    className?: string;
    dataTestId?: string;
}

export const PlainTextResult = ({
    answers,
    className = '',
    dataTestId = 'plain-text-result',
}: PlainTextResultProps) => {
    const nonEmptyAnswers = answers.filter((a) => a.text.trim().length > 0);

    if (nonEmptyAnswers.length === 0) {
        return null;
    }

    return (
        <div
            className={`space-y-3 pt-6 pb-8 ${className}`}
            data-testid={dataTestId}
        >
            {nonEmptyAnswers.map((answer, index) => (
                // The key never carries the author: on an anonymous feedback it would name them.
                <CommentAnswerCard
                    key={index}
                    answer={answer}
                    dataTestId={`${dataTestId}-item-${index}`}
                />
            ))}
        </div>
    );
};
